import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {EnvisiaObject} from '../../../common/wrapper.models';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';

export function useArticleCountBa(oaNr: string): UseQueryResult<EnvisiaObject<number>> {
  return useQuery({
    queryKey: ['oaNr', oaNr],
    queryFn: () =>
      AxiosHttpClient.get<EnvisiaObject<number>>(
        `/api/v1/workflow/business/order/article/production/${oaNr}`),
  });
}
